module.exports = __webpack_public_path__ + "images/icons/psp/climate-controlled/10x20.svg";